import { toast, Slide } from 'react-toastify';

export const toastConfig = {
  position: "bottom-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "dark",
  transition: Slide
};

export const showToast = {
  success: (message) => {
    toast.dismiss(); // Dismiss any existing toasts
    toast.success(message, toastConfig);
  },

  error: (error) => {
    toast.dismiss(); // Dismiss any existing toasts
    const message = error.reason || error.message || 'An error occurred';
    toast.error(message, {
      ...toastConfig,
      onClose: () => {
        // Cleanup on toast close if needed
      }
    });
  },

  info: (message) => {
    toast.dismiss(); // Dismiss any existing toasts
    toast.info(message, toastConfig);
  }
};